import { queryClient } from '@/Root';
import { useInfiniteQuery } from 'react-query';
import {
  WorkOrderAuditDataComplementItemsRequest,
  WorkOrderAuditDataComplementsRequest,
  WorkOrderAuditDataSalesRequest,
} from './AuditData.types';
import { PageRequest } from '@/core/request/PageRequest';
import { DEFAULT_ROWS } from '..';
import auditDataServices from './AuditData.services';
import notificationError from '@/utils/functions/notificationError';

export const QUERY_WORKORDER_AUDIT_COMPLEMENTS =
  'workorders/audit-data/complements';
export const QUERY_WORKORDER_AUDIT_SALES = 'workorders/audit-data/sales';
export const QUERY_WORKORDER_AUDIT_COMPLEMENT_ITEMS =
  'workorders/audit-data/complement-items';

export function useWorkOrderAuditComplements(
  params?: WorkOrderAuditDataComplementsRequest,
) {
  const cache = queryClient.getQueryData([
    QUERY_WORKORDER_AUDIT_COMPLEMENTS,
    { ...params },
  ]);

  return useInfiniteQuery({
    queryKey: [QUERY_WORKORDER_AUDIT_COMPLEMENTS, { ...params }],
    queryFn: ({ pageParam }) => {
      const req: PageRequest<'number'> = {
        nextToken: pageParam,
        order: params?.order || 1,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };

      return auditDataServices.complements(req);
    },
    enabled: !cache,
    getNextPageParam: (lastPage) => lastPage.nextToken,
    onError(error) {
      notificationError(error);
    },
  });
}

export function useWorkOrderAuditSales(
  params?: WorkOrderAuditDataSalesRequest,
) {
  const cache = queryClient.getQueryData([
    QUERY_WORKORDER_AUDIT_SALES,
    { ...params },
  ]);

  return useInfiniteQuery({
    queryKey: [QUERY_WORKORDER_AUDIT_SALES, { ...params }],
    queryFn: ({ pageParam }) => {
      const req: PageRequest<'number'> = {
        nextToken: pageParam,
        order: params?.order || 1,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };

      return auditDataServices.sales(req);
    },
    enabled: !cache,
    getNextPageParam: (lastPage) => lastPage.nextToken,
    onError(error) {
      notificationError(error);
    },
  });
}

export function useWorkOrderAuditComplementItems(
  params?: WorkOrderAuditDataComplementItemsRequest,
) {
  const cache = queryClient.getQueryData([
    QUERY_WORKORDER_AUDIT_COMPLEMENT_ITEMS,
    { ...params },
  ]);

  return useInfiniteQuery({
    queryKey: [QUERY_WORKORDER_AUDIT_COMPLEMENT_ITEMS, { ...params }],
    queryFn: ({ pageParam }) => {
      const req: PageRequest<'number'> = {
        nextToken: pageParam,
        order: params?.order || 1,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };

      return auditDataServices.complementItems(req);
    },
    enabled: !cache,
    getNextPageParam: (lastPage) => lastPage.nextToken,
    onError(error) {
      notificationError(error);
    },
  });
}
